import http from "./http";

class CategoriesService {
    index(){
        return http.get("/api/categories")
    }

    store(data,token){
        return http.post("/api/categories/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id,token){
        return http.get(`/api/categories/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return http.get(`/api/categories/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/categories/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/categories/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new CategoriesService()